/* eslint react/jsx-no-bind:0 */
import React, { Component } from "react"
import { Row,Col,Table, Button } from "react-bootstrap"
import { PropTypes } from "prop-types"
import moment from 'moment';
import  { videoblue, blue, red, warning, green } from '../../../utils/constants'

const EventStatusDesc = {
	RulesDenied: 'Rules Denied',
	RulesApproved: 'Rules Approved',
	UpcomingEvent: 'Upcoming Events',
  Completed: 'Completed',
  Canceled: 'Canceled',
	SetupNotCompleted: 'Setup Not Complete',
	PendingApproval: 'Pending Approval',
	PendingPost: 'Pending Post Event Report',
}

class SearchResults extends Component {

	constructor(props)
	{
		super(props)  
		this.setStatusColor = this.setStatusColor.bind(this)
		this.handleShowTransfer = this.handleShowTransfer.bind(this)
		this.handleShowAdjustment = this.handleShowAdjustment.bind(this)
	}

	handleShowAdjustment(event) {
		this.props.showAdjustment(event)
	}
	handleShowTransfer(event) {
		this.props.showTransfer(event)
	}

	setStatusColor(status)
	{
		switch(status)
		{			
			case EventStatusDesc.SetupNotCompleted:
			{
				return warning
			}
      case EventStatusDesc.PendingApproval:
      {
        return red
      }
			case EventStatusDesc.UpcomingEvent:
			{
				return videoblue
			}
			case EventStatusDesc.PendingPost:
			{
				return red
			}
      case EventStatusDesc.RulesDenied:
			{
				return red
			}
			case EventStatusDesc.Completed:
			{
				return green
        }
      case EventStatusDesc.Canceled:
      {
        return red
      }
		}    
	}
	render() {
		const {
			searchResults, 
		} = this.props;
		
		const recordsFound = (searchResults.length > 0);
	
		if (!recordsFound) {
			return (<span style={{ color:warning }}>
				<i className='fa fa-info-circle' />&nbsp;&nbsp;No events found
			</span>)
		}
		
		return (
		
			searchResults.length > 0 && 
			(
				<Row>
					<Col xs={12}>
						<Table striped>
							<thead>
								<tr>
									<th width='170px'>Season</th>
									<th width='250px'>Event Name</th>
									<th width='130px'>End Date</th>
									<th width='140px'>Amount Paid</th>
									<th width='120px'>Payment Due</th>  
									<th width='80px'>Balance</th>                  
									<th width='180px'>Status</th>
								</tr>
							</thead>
							<tbody>
								{
									searchResults.map((item, key) => ( 
									<tr key={key}>
										<td>{key + 1}{' .'} {item.season}</td>
										<td>{item.name}</td>
										<td>{moment(item.endDate).format('MM-DD-YYYY')}</td>
										<td>${item.amountPaid}</td>
										<td>${item.paymentDue}</td>
										<td style = {{ color:item.balance >= 0 ? 'green':'red' }} >${item.balance}</td>
										<td><span style={{ color:this.setStatusColor(item.eventStatus),fontSize:'90%' }}>{item.status}</span></td>
										<td>
											<Button onClick={() => this.handleShowTransfer(item)} style={{ color:blue }} disabled={item.balance <= 0}>
												<i className={ "fa fa-arrow-right"} aria-hidden="true"  />&nbsp;Transfer
											</Button> 
										</td>
										<td>
                        <Button onClick={() => this.handleShowAdjustment(item)} style={{ color: green }} disabled={item.status == EventStatusDesc.Completed || item.status == EventStatusDesc.Canceled}>
												<i className={ "fa fa-dollar"} aria-hidden="true"  />&nbsp;Fund Adjustment
											</Button>
										</td>                             
									</tr>))
								}
							</tbody>  	
						</Table>
					</Col>
				</Row>
			)
		)
	}
}
SearchResults.propTypes = {
	showTransfer: PropTypes.func,
	showAdjustment: PropTypes.func,
	searchResults: PropTypes.array,
}

export default SearchResults
  



// WEBPACK FOOTER //
// ./src/containers/deposit/components/searchresults.js